import * as React from 'react';
import Add from '../../media/icon-add.svg';
import Back from '../../media/icon-back.svg';
import Close from '../../media/icon-close.svg';
import Remove from '../../media/icon-remove.svg';
import Error from '../../media/icon-error.svg';
import Edit from '../../media/icon-edit.svg';
import Menu from '../../media/icon-menu.svg';
import Search from '../../media/icon-search.svg';
import Spinner from '../../media/icon-spinner.svg';
import Google from '../../media/icon-google.svg';
import Trash from '../../media/icon-trash.svg';
import CaretIcon from '../../media/icon-caret.svg';
import Refresh from '../../media/icon-refresh.svg';
import Input from '../../media/icon-input.svg';

const Disclose = () => <Back className="icon disclose"/>;
const Caret = ({ isOpen }) => <CaretIcon className={`icon caret ${isOpen ? `open` : `closed`}`}/>;

export default {
  Trash,
  Disclose,
  Refresh,
  Remove,
  Close,
  Edit,
  Menu,
  Caret,
  Google,
  Spinner,
  Search,
  Error,
  Back,
  Add,
  Input,
};



// WEBPACK FOOTER //
// ./src/components/static/Icons.js